import { Fragment, useEffect, useState, useMemo, useCallback} from "react";
import { useLocation } from "react-router-dom";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { faCogs, faEdit,faArrowsRotate,faPlay } from "@fortawesome/free-solid-svg-icons"; //sprint 22  - 8336 - Reset do Cache
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SafeDatatable } from "../../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";
import storageService from "../../../services/storage.service";

import { HeaderList } from "../../../components/HeaderList";

import { ConfigService } from "../../../services/config.service";

//sprint 22  - 8336 - Reset do Cache
import { DashboardService } from "../../../services/dashboard.service";
//sprint 22  - 8336 - Reset do Cache

import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import _ from 'lodash';
import { ValueDatatypeList } from "../../../models/config.model";
import { ButtonClean, ButtonSearch } from "../../../components/buttons";
import UtilService from "../../../services/util.service";

//sprint 22  - 8336 - Reset do Cache
import { CustomModal } from "../../../components/Modal";
import { ErrorHandler } from "../../../services/errorHandler.service";
import { ToastService } from "../../../services/toast.service";
//sprint 22  - 8336 - Reset do Cache

import { Spinner } from "react-bootstrap";

const ConfigList = () => {
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();

  const [data, setData] = useState<DatasetModel>();
  const history = useHistory();

  const user = storageService.getUser();

  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'config', filters: {
      config_key: [],
      config_value: [],
      description: [],
      config_key_description:[],
      iscustomer_record_edit_screen:[user.profile.profileName === "sys_admin"],
    },
    sort: {
      field: 'key',
      orientation: 'asc'
    }
  });

  
  //sprint 22  - 8336 - Reset do Cache
  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null,
  });
  //sprint 22  - 8336 - Reset do Cache

  //sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP
  const [showRemoveExModal, setShowRemoveExModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null,
  });
  //sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP

  const  actionexecuteExtraction= (id, name, entity) => {
    setShowRemoveExModal({ id: id, show: true, name: name, entity });
  };

  const actionResetCache = (id, name, entity) => {
    setShowRemoveModal({ id: id, show: true, name: name, entity });
  };

  const [configDescriptionText, setConfigDescriptionText] = useState('');

  const columns = [
    {
      key: "key",
      text: t('CONFIG.KEY'),
      align: "left",
      sortable: true,
    },
    {
      key: "key.description",
      text: t('CONFIG.DESCRIPTION'),
      align: "left",
      sortable: false,
      cell: (record) => {
        return t('CONFIG.' + record.key);
      },
    },
    {
      key: "configValue",
      text: t('CONFIG.VALUE'),
      align: "left",
      sortable: true,
    },
    {
      key: "valueDatatype",
      text: t('CONFIG.VALUEDATATYPE'),
      align: "left",
      sortable: true,
      cell: (record) => {
        let valueDatatype = '';
        if (record.valueDatatype) {
          let listValueDatatype = _.filter(ValueDatatypeList, { id: record.valueDatatype });
          if (listValueDatatype && listValueDatatype.length > 0) {
            valueDatatype = t('CONFIG.' + listValueDatatype[0].name);
          }
        }

        return valueDatatype;
      },
    },
    {
      key: "action",
      text: t('ACTIONS'),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => { history.push(`${pathname}/edit/${record.id}`) }}
                  //disabled={user.profile.profileName === "adm_reader" || (record.isCustomerRecordEditScreen === false || user.profile.profileName === "sys_admin")}
                  disabled={
                    user.profile.profileName === "sys_admin"
                      ? false
                      : user.profile.profileName === "adm_reader" ||
                        record.isCustomerRecordEditScreen === false
                  }                  
                  //disabled={false}
                >
                  <FontAwesomeIcon icon={faEdit} className='me-2' /> {t('EDIT')}
                </Dropdown.Item>
                {/* sprint 22  - 8336 - Reset do Cache */}
                {record.key == 'EQUIPMENT_CACHE' &&
                  <Dropdown.Item
                    className='fw-bold'
                    onClick={() => actionResetCache(record.id, '', record)}
                  >
                    <FontAwesomeIcon icon={faArrowsRotate} className='me-2' /> {t('RESET')}
                  </Dropdown.Item>
                //sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP
                }
                {record.key == 'LAST_EQP_IND_EXCEL_SCHED_DATE' &&
                  <Dropdown.Item
                    className='fw-bold'
                    onClick={() => actionexecuteExtraction(record.id, '', record)}
                  >
                    <FontAwesomeIcon icon={faPlay} className='me-2' /> {t('EXECUTE')}
                  </Dropdown.Item>
                //sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP
                }
              </Dropdown.Menu>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  function normalize(text) {
    return String(text || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  const configTranslations = useMemo(() => {
    const config = t("CONFIG", { returnObjects: true });
    return Object.entries(config || {});
  }, [t, idiom]);

  const searchConfig = useCallback((search) => {
    const words = normalize(search)
      .split(/\s+/)
      .filter(Boolean);

    if (words.length === 0) return [];

    return configTranslations
      .filter(([key, value]) => {
        const text = normalize(value);
        return words.some(word => text.includes(word));
      })
      .map(([key, value]) => ({
        key,
        translation: value
      }));
  }, [configTranslations]);


  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride || dataset] };
    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "key";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await ConfigService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'config' }));

      if (user?.profile?.profileName === "sys_admin" && d?.data?.length) 
      {
        d.data = d.data.filter(item =>
            item.key !== 'LAST_BALANCE_REC_PREV_DAY' &&
            item.key !== 'LAST_QUEUE_ID_BY_REGRESSION'
        );
      };

      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };

  //sprint 22  - 8336 - Reset do Cache
  const handleCloseModal = () =>
  setShowRemoveModal({ id: 0, show: false, name: "", entity: null });
  //sprint 22  - 8336 - Reset do Cache

   //sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP
  const handleCloseExecuteModal = () =>
  setShowRemoveExModal({ id: 0, show: false, name: "", entity: null });
   //sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP
  
  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();

      const trimconfigkey = dataset.filters.config_key?.[0]?.trim() || "";
      const trimconfigvalue = dataset.filters.config_value?.[0]?.trim() || "";

      const configkeydescription = configDescriptionText && configDescriptionText.trim() !== ''
      ? searchConfig(configDescriptionText).map(item => item.key)
      : []; 

      const iscustomerrecordeditscreen =  user.profile.profileName === "sys_admin";

      const cleanedDataset = {
        ...dataset,
        filters: {
          ...dataset.filters,
          config_key: [trimconfigkey],
          config_value: [trimconfigvalue],
          config_key_description: configkeydescription,
          iscustomer_record_edit_screen: [iscustomerrecordeditscreen],
        },
      };
    await getList(null,cleanedDataset);
  };
//sprint 22  - 8336 - Reset do Cache
  const cachereset = async () => {
    setLoading(true);
      try {

        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };
        
        const response: any = await DashboardService.equipmentCacheReset(requestParams);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('CONFIG.EQUIPMENT_CACHE_RESETED'));
            await getList(null);
            handleClean();
            handleCloseModal();
          }
        }
      } catch (error) {
      }
      setLoading(false);
  };
//sprint 22  - 8336 - Reset do Cache

//sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP
  const executeExtraction = async () => {
    setLoading(true);
      try {

        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };
        
        const response: any = await DashboardService.setequipmentextractionprogressexcel(requestParams);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('CONFIG.EQUIPMENT_EXTRACTION_EXECUTED'));
            await getList(null);
            handleClean();
            handleCloseExecuteModal();
          }
        }
      } catch (error) {
      }
      setLoading(false);
  };
//sprint 48  - execução da extração diária que gera a planilha de indicadores do BDP

  const tableChangeHandler = async (data) => {

    await getList(data);
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => { //sprint 22  - 8336 - Reset do Cache

    setConfigDescriptionText('');
    setDataset({
      ...dataset, filters: {
        config_key: [],
        config_value: [],
        description: [],
        config_key_description: [],
        iscustomer_record_edit_screen: [user.profile.profileName === "sys_admin"],
      },
      sort: {
        field: "",
        orientation: "",
      },
    });
    setFlagClear(true);
  };

  const initialize = async () => {
    await getList(null);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderList title={t(`CONFIG.TITLE_LIST`)} />
      {/* sprint 22  - 8336 - Reset do Cache */}
      <CustomModal
        Title={t("RESET")}
        Message={`${t("RESET_ANSWER")} ${
          showRemoveModal ? showRemoveModal.name : ""
        }?`}
        close={handleCloseModal}
        cancel={t("CANCEL")}
        show={showRemoveModal ? showRemoveModal.show : false}
        isLoading={isLoading}
        >
        <Button variant='primary' onClick={cachereset} disabled={isLoading}>
          {isLoading && (
            <Spinner
              animation="border"
              size="sm"
              className="me-2"
            />
          )}          
          {t("YES")}
        </Button>
      </CustomModal>
      {/* sprint 22  - 8336 - Reset do Cache */}

      {/* Modal de Execução de Extração */}
      <CustomModal
        Title={t("EXECUTE")}
        Message={`${t("EXECUTE_ANSWER")} ${
          showRemoveExModal ? showRemoveExModal.name : ""
        }?`}
        close={handleCloseExecuteModal}
        cancel={t("CANCEL")}
        show={showRemoveExModal ? showRemoveExModal.show : false}>
        <Button variant="primary" onClick={executeExtraction}>
          {t("YES")}
        </Button>
      </CustomModal>

      <Form>
        <Form.Label>{t('FILTERS')}</Form.Label>
        <Row>
          <Col xs={12} sm={6} md={6} lg={3}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='config_key'
                  id='config_key'
                  type='text'
                  placeholder={t('FILTER.CONFIG_KEY')}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, config_key: [e.target.value] } })
                  }}
                  value={dataset?.filters?.config_key.length > 0 ? dataset.filters.config_key[0] : ''}
                />
                <label htmlFor="config_key">{t("FILTER.CONFIG_KEY")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs={12} sm={6} md={6} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='config_value'
                  id='config_value'
                  type='text'
                  placeholder={t('FILTER.CONFIG_VALUE')}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, config_value: [e.target.value] } })
                  }}
                  value={dataset?.filters?.config_value.length > 0 ? dataset.filters.config_value[0] : ''}
                />
                <label htmlFor="config_value">{t("FILTER.CONFIG_VALUE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs={12} sm={6} md={6} lg={4}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name="config_key_description"
                  id="config_key_description"
                  type="text"
                  placeholder={t('CONFIG.DESCRIPTION')}
                  className="form-control"
                  onChange={(e) => {
                    const value = e.target.value;

                    setConfigDescriptionText(value);

                    const configkeydescription =
                      value && value.trim() !== ""
                        ? searchConfig(value).map(item => item.key)
                        : [];

                    setDataset(prev => ({
                      ...prev,
                      filters: {
                        ...prev.filters,
                        config_key_description: configkeydescription
                      }
                    }));
                  }}                  
                  value={configDescriptionText}
                />
                <label htmlFor="config_key_description">{t("CONFIG.DESCRIPTION")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="auto">
            <ButtonSearch onClick={handleSearch} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => {e.preventDefault(); handleClean();}} /> {/* sprint 22  - 8336 - Reset do Cache */}
          </Col>

        </Row>
      </Form>
      
      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
      />
    </>
  );
};

export default ConfigList;